import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { placesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useTableActions } from '../../../../components/tables/MultiSelectTableContext'

const MUTATION = gql`
  mutation RemovePlaces($ids: [Int]) {
    removePlaces(ids: $ids)
  }
`

export const useRemovePlaces = () => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Places', 'PlacesCount'], client: placesClient })
  const notify = useNotification()
  const modal = useAlert()
  const closeModal = useCloseModal()
  const { clearSelection } = useTableActions()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!resp.errors) {
        if (clearSelection) clearSelection()
        if (closeModal) closeModal()
      } else {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
